import { render, staticRenderFns } from "./AdminAuthorizingPersonForm.vue?vue&type=template&id=f604ed2e&scoped=true&"
import script from "./AdminAuthorizingPersonForm.vue?vue&type=script&lang=js&"
export * from "./AdminAuthorizingPersonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f604ed2e",
  null
  
)

export default component.exports